var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.179 6.001c1.053.008 6.354.09 7.043.81.77.802.778 4.763.778 4.785 0 0-.006 3.981-.778 4.786-.766.8-7.225.818-7.225.818s-6.458-.017-7.227-.818c-.691-.722-.762-3.996-.77-4.666v-.237c.008-.666.079-3.946.77-4.668.692-.72 5.992-.802 7.045-.81ZM9.6 8.4v6.4l6.4-3.2z"
})));
export default SvgGemChannelYoutube;